import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ar from '@/configs/language/lang/ar'
import bn from '@/configs/language/lang/bn'
import en from '@/configs/language/lang/en'
import es from '@/configs/language/lang/es'
import fr from '@/configs/language/lang/fr'
import hi from '@/configs/language/lang/hi'
import id from '@/configs/language/lang/id'
import pt from '@/configs/language/lang/pt'
import ru from '@/configs/language/lang/ru'
import th from '@/configs/language/lang/th'
import tr from '@/configs/language/lang/tr'
import tw from '@/configs/language/lang/tw'
import ur from '@/configs/language/lang/ur'
import vi from '@/configs/language/lang/vi'
import zh from '@/configs/language/lang/zh'

Vue.use(VueI18n)

const messages = {
  ar,
  bn,
  en,
  es,
  fr,
  hi,
  id,
  pt,
  ru,
  th,
  tr,
  tw,
  ur,
  vi,
  zh
}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

const defaultLang = 'en'
// 支持的语种
const supportedLanguages = ['ar', 'bn', 'en', 'es', 'fr', 'hi', 'id', 'pt', 'ru', 'th', 'tr', 'tw', 'ur', 'vi', 'zh']

function setI18nLanguage(lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguage(lang) {
  if (lang === 'zh-TW') lang = 'tw'
  else lang = lang.split('-')[0]
  // 不支持的语种使用默认语言
  if (!supportedLanguages.includes(lang)) lang = defaultLang
  setI18nLanguage(lang)
  // 阿语镜像
  if (lang === 'ar' || lang === 'ur') {
    localStorage.setItem('isMirror', '1')
  } else {
    localStorage.setItem('isMirror', '0')
  }
  localStorage.setItem('language', lang === 'zh' ? 'zh-CN' : lang === 'tw' ? 'zh-TW' : lang) // 设置全局语言
}

export default i18n



// WEBPACK FOOTER //
// ./src/configs/language/index.js